import { FC, useMemo } from 'react';
import { Chip, Grid, Stack, Typography } from '@mui/material';
import { BoxWell } from '@shared/components/BoxWell';
import { format } from 'date-fns';
import { FiberManualRecord } from '@mui/icons-material';


interface Props extends Users.PreferenceHistoryItem {
  version?: string;
}

export const PreferenceHistoryItem: FC<Props> = (props) => {
  const {
    historyDate,
    leadershipValue1,
    leadershipValue2,
    leadershipValue3,
    communicationObjective1,
    communicationObjective2,
    communicationObjective3,
    version,
  } = props;

  const values = useMemo(() => {
    return [
      leadershipValue1,
      leadershipValue2,
      leadershipValue3,
    ].filter(Boolean);
  }, [leadershipValue1, leadershipValue2, leadershipValue3]);

  const objectives = useMemo(() => {
    return [
      communicationObjective1,
      communicationObjective2,
      communicationObjective3,
    ].filter(Boolean);
  }, [communicationObjective1, communicationObjective2, communicationObjective3]);

  return (
    <BoxWell sx={{ borderColor: 'primary.main', background: '#f0f1f5' }}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Chip label={version} color="primary" size="small"/>
        <Typography variant="body2" fontWeight={600}>
          {format(historyDate, 'MM-dd-yyyy')}
        </Typography>
      </Stack>

      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" fontSize={12} fontWeight={500} mb={1} color="text.secondary">
            Values ({values.length})
          </Typography>
          <Stack gap={0.2}>
            {values.map((value, index) => (
              <PreferenceItem key={index} text={value}/>
            ))}
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography variant="body2" fontSize={12} fontWeight={500} mb={1} color="text.secondary">
            Objectives ({objectives.length})
          </Typography>
          <Stack gap={0.2}>
            {objectives.map((objective, index) => (
              <PreferenceItem key={index} text={objective}/>
            ))}
          </Stack>
        </Grid>
      </Grid>
    </BoxWell>
  );
};

interface PreferenceItemProps {
  text?: CVT.MaybeNull<string>;
}

const PreferenceItem: FC<PreferenceItemProps> = ( props ) => {
  const { text } = props;

  if (!text) return null;

  return (
    <Stack direction="row" alignItems="flex-start" gap={1}>
      <FiberManualRecord sx={{ fontSize: 6, color: 'text.secondary', mt: 1 }}/>
      <Typography variant="body1" fontSize={12} component="span">
        {text}
      </Typography>
    </Stack>
  );
};
